import { Button, Stack, Typography } from '@mui/material';
import { EndpointUrl } from 'api/endpoint';
import { useFetch } from 'api/fetcher';
import { useField } from 'api/fieldEditor';
import { FieldEditor } from 'components/FieldEditor';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FinsightEntityField } from 'shared';

export default function FieldEditorPage() {
  const params = useParams();

  const fieldType = params.fieldType ?? null;
  const fieldName = params.fieldName ?? null;

  const fieldTypes = useField(fieldType);

  const fieldData = useMemo(
    () => fieldTypes.data?.find((x) => x.name === fieldName),
    [fieldName, fieldTypes.data],
  );

  const [field, setField] = useState<FinsightEntityField['schema'] | undefined>(
    fieldData?.schema,
  );

  const fieldPayload = useMemo(
    () => ({
      type: fieldType,
      name: fieldName,
      schema: field,
    }),
    [field, fieldName, fieldType],
  );

  const { fetcher: createOrUpdateField, workspaceId } = useFetch(
    'POST',
    fieldPayload,
  );

  useEffect(() => {
    setField(fieldData?.schema);
  }, [fieldData?.schema]);

  if (!fieldName) {
    return <div>No field name</div>;
  }

  return (
    <Stack gap={2} mt={2}>
      <Stack>
        <Typography fontWeight="bold">Field Editor</Typography>
        <Typography variant="h5">{fieldData?.name}</Typography>
      </Stack>
      <Button
        onClick={async () => {
          await createOrUpdateField(
            `${EndpointUrl}/workspace/${workspaceId}/field/${fieldPayload.type}/${fieldPayload.name}`,
          );
        }}
      >
        Save
      </Button>
      {field && (
        <FieldEditor fieldName={fieldName} field={field} setField={setField} />
      )}
    </Stack>
  );
}
